import { __rest, __assign } from 'tslib';
import React__default from 'react';
import { useNotificationsCenter } from './hooks.js';
import { StyledNotificationsCenterPositionner, classes } from './index.styled.js';
import Notification from './Notification/index.js';

var NotificationsCenter = function () {
    var _a = useNotificationsCenter(), notificationPositionned = _a.notificationPositionned, dismiss = _a.dismiss;
    return (React__default.createElement(React__default.Fragment, null, notificationPositionned.map(function (_a) {
        var position = _a.position, notifications = _a.notifications;
        if (notifications.length === 0) {
            return null;
        }
        return (React__default.createElement(StyledNotificationsCenterPositionner, { "data-testid": "NotificationsCenter-Positionner", key: position, notificationPosition: position, className: "NotificationsCenter-Positionner NotificationsCenter-Positionner-".concat(position) }, notifications.map(function (_a) {
            var id = _a.id, rest = __rest(_a, ["id"]);
            return (React__default.createElement(Notification, __assign({ className: classes.notification, key: id, notificationId: id }, rest, { onDismiss: dismiss })));
        })));
    })));
};

export { NotificationsCenter as default };
//# sourceMappingURL=index.js.map
